import { useTranslation } from "react-i18next";
import Button from "containers/pmaOnboarding/components/pages/contract/button";
import { ReactComponent as Warning } from "assets/icons/warning-primary-circule.svg";

const Information = ({ loadingOTP, userInfo, onChangedMode, onSendOTP }) => {
  const { t } = useTranslation();
  const isEmailExist = [undefined, "", null].includes(userInfo?.email_address);

  return (
    <div>
      <div
        className={`"border border-gray--8 p-1 bg-gray--13 rounded-lg ${
          isEmailExist ? "mb-2 " : "mb-14"
        }`}
      >
        <div className="flex flex-col gap-4 px-4 rounded-lg bg-white ">
          <div className="flex flex-col gap-2 body-14px-medium ">
            <span className="text-gray-0">
              {t("pma-onboarding.assets-owner")}:
            </span>
            <span className="text-gray--2 bg-gray--9 p-2 rounded-lg body-14px-medium">
              {userInfo?.pma_owner}
            </span>
          </div>
          <div className=" flex flex-col gap-2 body-14px-medium ">
            <div className="flex justify-between">
              <span className="text-gray-0">{t("email")}:</span>
              <Button
                className="flex gap-1 items-center !bg-transparent !p-0 !w-auto border-none !shadow-none min-h-0 h-aut! !text-blue-0 caption-12px-demibold"
                title={"edit"}
                onClick={() => onChangedMode("email")}
              />
            </div>
            <span className="text-gray--2 bg-gray--9 p-2 rounded-lg body-14px-medium">
              {isEmailExist ? "-" : userInfo.email_address}
            </span>
            {isEmailExist && (
              <span
                className={`flex items-start  gap-1 caption-12px-medium  transition-all delay-50  text-gray-0`}
              >
                <Warning className="[&>path]:fill-gray-0 relative top-1" />
                {t("pma-onboarding.email-hit")}:
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2 body-14px-medium ">
            <div className="flex justify-between">
              <span className="text-gray-0">{t("address")}: </span>
              <Button
                className="flex gap-1 items-center !bg-transparent !p-0 !w-auto border-none !shadow-none min-h-0 h-aut! !text-blue-0 caption-12px-demibold"
                title={"edit"}
                onClick={() => onChangedMode("address")}
              />
            </div>
            <span className="text-gray--2 bg-gray--9 p-2 rounded-lg body-14px-medium ">
              {userInfo?.city
                ? `
                  ${userInfo?.city ? `${userInfo?.city} - ` : ""} 
                  ${userInfo?.address} - 
                  ${userInfo?.unit ? `${t("unit")} ${userInfo?.unit} - ` : ""} 
                  ${userInfo?.tel ? `${t("number")} ${userInfo?.tel} ` : ""} 
                `
                : userInfo?.address_detail}
            </span>
          </div>
          <div className=" flex flex-col gap-2 body-14px-medium ">
            <span className="text-gray-0">{t("postcode")}: </span>
            <span className="text-gray--2 bg-gray--9 p-2 rounded-lg body-14px-medium">
              {userInfo?.postal_code || userInfo?.postalcode}
            </span>
          </div>
        </div>
      </div>

      <div className="relative  mt-5 pt-5 ">
        <div className="before:bg-gray--7 before:content-['']  before:w-[calc(100%+40px)] before:h-[1px] before:absolute before:right-[-20px] before:top-[0px] " />
        <Button
          disabled={isEmailExist}
          loading={loadingOTP}
          title={"accept"}
          onClick={onSendOTP}
        />
      </div>
    </div>
  );
};

export default Information;
